module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showClip),
      expression: "!showClip"
    }],
    staticClass: "evaluateImgCon"
  }, [_vm._l((_vm.imagePreviewList), function(img, index) {
    return _c('section', {
      staticClass: "evaluateImgItem",
      class: {
        uploading: img.isUploading, error: img.isError
      },
      attrs: {
        "track-by": "$index"
      }
    }, [_c('img', {
      staticClass: "evaluateImg",
      attrs: {
        "alt": "",
        "src": img.data
      },
      on: {
        "click": function($event) {
          _vm.imgSwiper(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uploading-box"
    }, [_vm._v("上传中...")]), _vm._v(" "), _c('div', {
      staticClass: "error-box"
    }, [_vm._v("上传失败")]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "cover"
    }, [_vm._v("封面")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delIcon",
      on: {
        "click": function($event) {
          _vm.delImage(index, img)
        }
      }
    })])
  }), _vm._v(" "), (_vm.imagePreviewList.length < _vm.max) ? _c('div', {
    staticClass: "evaluateUploadImg",
    on: {
      "click": function($event) {
        _vm.openUploadPop($event)
      }
    }
  }, [_c('span', {
    staticClass: "uploadIcon"
  }), _vm._v(" "), (_vm.isClip) ? [_c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadImg
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.isClip) ? [(_vm.isIOS || !_vm.isWx) ? _c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadImg
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isIOS && _vm.isWx) ? _c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "camera",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadImg
    }
  }) : _vm._e()] : _vm._e()], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSwiper),
      expression: "isSwiper"
    }],
    staticClass: "swiper-layout"
  }, [_c('div', {
    staticClass: "swiper-container",
    on: {
      "click": _vm.hideSwiper
    }
  }, [_c('div', {
    staticClass: "swiper-guide"
  }, [_c('span', [_vm._v(_vm._s(_vm.currSwiperIndex))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.imagePreviewList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.imagePreviewList), function(img, index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": img.data,
        "alt": ""
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClip && _vm.showClip),
      expression: "isClip && showClip"
    }],
    staticClass: "clip-container"
  }, [_c('img', {
    staticClass: "clip-img",
    attrs: {
      "src": _vm.clipImgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clip-wrap"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClip),
      expression: "showClip"
    }],
    staticClass: "clip-save-btn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.saveClipImg($event)
      },
      "touchmove": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      }
    }
  }, [_vm._v("保存效果")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32f99c87", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f99c87","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImgUpload.vue
// module id = 84
// module chunks = 0